import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
	selector: 'kwo-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	standalone: true,
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {

	currentYear = new Date().getFullYear();

	constructor() { }

	ngOnInit(): void {
	}

}
